import { render, staticRenderFns } from "./CustomEdit.vue?vue&type=template&id=8525da74"
import script from "./CustomEdit.vue?vue&type=script&lang=js"
export * from "./CustomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports